import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { Button } from '../../subkit-ui';
import { Information } from '../Information';
import { Modal } from '../Modal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ConfirmationModal = function ConfirmationModal(_ref) {
  var heading = _ref.heading,
      body = _ref.body,
      cancelText = _ref.cancelText,
      confirmText = _ref.confirmText,
      onConfirm = _ref.onConfirm,
      showModal = _ref.showModal,
      styles = _ref.styles,
      setModal = _ref.setModal,
      confirmButtonType = _ref.confirmButtonType,
      loading = _ref.loading;
  return /*#__PURE__*/_jsx(Modal, {
    showModal: showModal,
    setModal: setModal,
    children: /*#__PURE__*/_jsxs("div", {
      style: _objectSpread({}, styles),
      children: [/*#__PURE__*/_jsx(Information, {
        heading: heading,
        body: body,
        styles: {
          heading: 'mb-0 leading-snug',
          body: 'mb-0 leading-snug'
        }
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col md:flex-row mt-6",
        children: [/*#__PURE__*/_jsx("div", {
          className: "mb-4 md:mb-6 md:mr-6 md:mb-0",
          children: /*#__PURE__*/_jsx(Button, {
            text: confirmText,
            onClick: onConfirm,
            type: confirmButtonType,
            "data-cy": "confirmation-modal-activate-button",
            classes: "w-full md:w-auto",
            disabled: loading
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Button, {
            text: cancelText,
            onClick: function onClick() {
              return setModal({
                show: false
              });
            },
            type: "secondary",
            classes: "w-full md:w-auto"
          })
        })]
      })]
    })
  });
};
ConfirmationModal.defaultProps = {
  cancelText: 'Nevermind',
  styles: {
    width: '100%'
  },
  confirmButtonType: 'warning',
  loading: false
};